import { getBooleanFromValue } from '@/global/utils/utils'

export default {
  data () {
    return {
      basicInfoPermissions: {}
    }
  },

  computed: {
    vehicleTagConfig () {
      return {
        title: this.$t('fleet/vehicle/basic_info_tab.tab_label'),
        key: 'vehicleTags',
        apiConfig: {
          post: {
            module: 'fleet',
            route: this.createMode ? 'vehicle-tags' : `vehicle-tags/${this.$route.params.id}`
          }
        },
        validationErrors: this.validationErrors,
        afterSave: () => {
          this.createMode = false
        },
        onDataReceived: (event) => {
          this.basicInfoPermissions = event?.meta?.permissions || {}
        },
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('base.back'),
            showEditBtn: getBooleanFromValue(this.basicInfoPermissions?.canUpdate),
            showBackButton: {
              onGoBack: () => this.goBack()
            },
            onCancelTabSave: (event) => this.cancelTabSave(event),
            onSaveClick: async (event) => {
              const { saveTab } = event || {}
              if (typeof saveTab === 'function') {
                await saveTab()
              }
            }
          },
          {
            component: this.columnsContentComponent,
            rows: [
              {
                disabled: !getBooleanFromValue(this.basicInfoPermissions?.canUpdate),
                columnsCount: 2,
                fields: [
                  {
                    key: 'name',
                    label: this.$t('fleet/vehicle_document.name'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'color',
                    type: 'color',
                    colStyle: {
                      alignContent: 'end'
                    },
                    label: this.$t('locations/location.color'),
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  watch: {
    createMode: {
      immediate: true,
      handler (val) {
        if (!val) {
          this.$set(this.vehicleTagConfig.apiConfig, 'get', {
            module: 'fleet',
            route: `vehicle-tags/${this.$route.params.id}`,
            method: 'get'
          })
          this.$delete(this.vehicleTagConfig.tabContent[0], 'onCancelTabSave')
        }
        else {
          this.$delete(this.vehicleTagConfig.apiConfig, 'get')
          this.$set(this.vehicleTagConfig.tabContent[0], 'onCancelTabSave', (event) => this.cancelTabSave(event))
        }
      }
    }
  },

  methods: {
    goBack () {
      if (this.createMode) {
        this.createMode = false
      }
      else {
        this.$router.replace({ name: 'VehicleTags' })
      }
    },

    cancelTabSave (event) {
      const { cancelTabSave } = event || {}
      if (this.createMode) {
        this.createMode = false
      }
      else {
        cancelTabSave()
      }
    }
  }
}
